export const ACTION_RESET = 'FETCH_VIDEO_CATEGORY_RESET';
export const ACTION_REQUEST = 'FETCH_VIDEO_CATEGORY_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEO_CATEGORY_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEO_CATEGORY_ERROR';
